import React from 'react';
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from 'lucide-react';
import { registrationSteps } from '../../data/registration';
import { useProto } from '../../contexts/PrototypeContext';
import type { CustomerStep } from '../../types/volunteer';
const stepIndex: Record<CustomerStep, number> = {
  volunteer: 3,
  cart: 4,
  confirmed: 5
};
export function RegistrationHeader({
  device
}: {
  device: 'mobile' | 'desktop';
}) {
  const {
    state,
    actions
  } = useProto();
  const active = stepIndex[state.step];
  const canPrev = state.step === 'cart';
  const goPrev = () => canPrev && actions.goToStep('volunteer');
  if (device === 'mobile') {
    return <nav aria-label="Registration steps" className="sticky top-0 z-10 flex h-[50px] shrink-0 font-i9 text-white" data-id="element-308" data-mp="437ucvxkisz3">
        <button type="button" aria-label="Previous step" disabled={!canPrev} onClick={goPrev} className="flex w-12 items-center justify-center bg-i9-navyDeep disabled:opacity-60" data-id="element-309" data-mp="93c9oimqphnq">
          <ChevronsLeftIcon className="h-5 w-5" data-id="element-310" data-mp="mh7nyc1m588b" />
        </button>
        <div className="flex flex-1 items-center justify-center gap-2 bg-i9-red text-[16px] font-bold" data-id="element-311" data-mp="hhutb54i2wv6">
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-[12px] text-i9-red" data-id="element-312" data-mp="cii62j9pvns2">{active + 1}</span>
          {registrationSteps[active]}
          <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-313" data-mp="8j9e9jy8lzz5" />
        </div>
        <button type="button" aria-label="Next step" disabled className="flex w-12 items-center justify-center bg-i9-navyDeep opacity-60" data-id="element-314" data-mp="156xkb3l0y22c">
          <ChevronsRightIcon className="h-5 w-5" data-id="element-315" data-mp="vhmcdk9vj3g1" />
        </button>
      </nav>;
  }
  return <nav aria-label="Registration steps" className="sticky top-0 z-10 flex h-[52px] shrink-0 bg-i9-navy font-i9 text-white" data-id="element-316" data-mp="rg0rpcr3lkva">
      <button type="button" aria-label="Previous step" disabled={!canPrev} onClick={goPrev} className="flex w-[56px] items-center justify-center bg-i9-navyDeep disabled:opacity-60" data-id="element-317" data-mp="1ny6t1amz0msv">
        <ChevronLeftIcon className="h-5 w-5" data-id="element-318" data-mp="3dfc6p2fsppui" />
      </button>
      <ol className="flex flex-1" data-id="element-319" data-mp="3dfu6g91o2m76">
        {registrationSteps.map((label, i) => {
        const isActive = i === active;
        const done = i < active;
        const target: CustomerStep | null = state.step !== 'confirmed' ? i === 3 ? 'volunteer' : i === 4 ? 'cart' : null : null;
        return <li key={label} className={`flex-1 ${isActive ? 'bg-i9-red' : done ? 'bg-i9-steel' : 'bg-i9-navy'}`} data-id="element-320" data-mp="38lziuuixxn2t" data-mpi={i}>
              <button type="button" disabled={!target || isActive} aria-current={isActive ? 'step' : undefined} onClick={() => target && actions.goToStep(target)} className="flex h-full w-full items-center justify-center gap-2 whitespace-nowrap px-2 text-[13.5px] font-semibold disabled:cursor-default" data-id="element-321" data-mp="2zne2n60xyk57">
                <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[12px] font-bold ${isActive ? 'bg-white text-i9-red' : done ? 'bg-i9-navyDeep' : 'border-2 border-white/80'}`} data-id="element-322" data-mp="nxuyy88grm8i">
                  {i + 1}
                </span>
                {label}
              </button>
            </li>;
      })}
      </ol>
      <button type="button" aria-label="Next step" disabled className="flex w-[56px] items-center justify-center bg-i9-navyDeep opacity-60" data-id="element-323" data-mp="2de79ra5gajxa">
        <ChevronRightIcon className="h-5 w-5" data-id="element-324" data-mp="2r8q5j2qw2p6m" />
      </button>
    </nav>;
}